const map: {
  [propName: string]: Array<{
    label: string;
    key: string;
    // [propName: string]: string | number | Array<{ label: string; key: string; [propName: string]: string | number }>;
  }>;
} = {
  'avatar-item': [
    {
      label: '@他',
      key: 'at-user',
    },
  ],
  'self-avatar-item': [],
  'msg-item': [
    // {
    //   label: '引用',
    //   key: 'quote',
    // },
    {
      label: '收藏',
      key: 'collect',
    },
  ],
  'chat-item': [
    {
      label: '置顶',
      key: 'top-chat-item',
    },
    {
      label: '標記',
      key: 'mark-chat-item',
    },
    {
      label: '标签',
      key: 'tag-chat-item',
    },
  ],
  'mentions-input': [
    {
      label: '粘贴',
      key: 'paste',
    },
  ],
  'context-edit-remove': [
    {
      label: '編輯',
      key: 'context-edit',
    },
    {
      label: '刪除',
      key: 'context-remove',
    },
  ],
};

export default map;
